var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"example"},[_c('apexchart',{ref:"demoChart",attrs:{"type":"heatmap","width":this.chartWidth,"height":this.chartHeight,"options":_vm.chartOptions,"series":_vm.series}},[_vm._v(_vm._s())])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }